module.exports = __webpack_public_path__ + "d8c9136c.svg";